const POST_ADD_ANSWER_URL = "/apps/know-yourself/add";
const GET_LAST_ANSWER_URL = "/apps/know-yourself/result/last.json";

export { POST_ADD_ANSWER_URL, GET_LAST_ANSWER_URL };
